import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/youxi-zixun", label: "游戏资讯" },
  { to: "/liandong-qingbao", label: "联动情报" },
  { to: "/xinyou-manhuahu", label: "新游漫画化" },
  { to: "/banben-gengxin", label: "版本更新" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-background-50/80 backdrop-blur-sm"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="manga-clip-both flex h-9 w-9 items-center justify-center bg-primary-500 text-background-50">
            <i className="ri-palette-line text-lg" />
          </span>
          <span className="font-heading text-xl leading-none text-foreground-950">
            可游<span className="text-primary-500">漫画</span>网
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                pathname === link.to
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <Link
            to="/contact"
            className="manga-clip whitespace-nowrap bg-accent-500 px-4 py-2 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            投稿咨询
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md bg-background-100 text-foreground-800 md:hidden"
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`mt-1 flex items-center gap-2 rounded-md px-3 py-2.5 text-sm font-medium ${
                pathname === link.to
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 flex items-center justify-center gap-2 rounded-md bg-accent-500 px-3 py-2.5 text-sm font-bold text-foreground-950"
          >
            投稿咨询
          </Link>
        </div>
      )}
    </header>
  );
}